/* eslint-disable no-unused-vars */
import {News} from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    selectedNews: null,
    news: [],
    count: 0
  },
  actions: {
    async fetchNews({commit}, options) {
      const news = await News.fetch({...options, _sort: 'createdAt:DESC'})
      commit('setNews', news)
      return news
    },
    async fetchNewForUser({commit}, options) {
      const news = await News.fetch({...options, _sort: 'createdAt:DESC'})
      commit('setNews', news)
      return news
    },
    async fetchNewsById({commit}, id) {
      const news = await News.fetchOne(id)
      return news
    },

    async createNews({commit}, data) {
      const newNews = await News.create(data)
      return newNews
    },

    async updateNews({commit, state}, {id, ...data}) {
      const updatedNews = await News.update(id, {...data})
      commit('setSelectedNews', updatedNews)
      commit(
        'setNews',
        state.news.map(news => (news.id === id ? updatedNews : news))
      )
      commit('setCount', state.news.filter(news => news.status === 'unseen').length)
      return updatedNews
    },

    async deleteNews({commit}, id) {
      await News.remove(id)
    },

    async countNews({commit}, options) {
      const count = await News.count({...options})
      commit('setCount', count)
      return count
    }
  },
  mutations: {
    setCount(state, count) {
      state.count = count
    },
    setNews(state, newsdata) {
      state.news = newsdata
    },
    setSelectedNews(state, news) {
      state.selectedNews = news
    }
  },
  getters: {
    getNews: state => {
      return state.news
    },
    getSelectedNews: state => {
      return state.selectedNews
    },
    getCount: state => {
      return state.count
    }
  }
}
/* eslint-enable no-unused-vars */
